export const lastPublish = '14.07.23 09:52';
